import { Location } from 'vue-router';

export interface NewsLocation {
  toNewsListLocation: (
    params: { newsId: number },
  ) => Location;

  toNewsDetailLocation: (
    params: { newsId: number },
  ) => Location;
}

export const useNewsLocation = (): NewsLocation => {
  const toNewsListLocation = (params): Location => {
    return {
      name: 'news-list',
      params,
    };
  };

  const toNewsDetailLocation = (params): Location => {
    return {
      name: 'news-detail',
      params,
    };
  };

  return {
    toNewsListLocation,
    toNewsDetailLocation,
  };
};
